import { isApiError } from '@nucleus-commerce/api-client/transport';

/** Counts of a 409 SELECTION_CHANGED: what the request expected and what the filter matches now. */
export interface SelectionChange {
  expected: number;
  actual: number;
}

/** The counts of a 409 SELECTION_CHANGED, or null for any other error. */
export function selectionChanged(error: unknown): SelectionChange | null {
  if (!isApiError(error) || error.code !== 'SELECTION_CHANGED') return null;
  const { expected, actual } = error.meta;
  return typeof expected === 'number' && typeof actual === 'number' ? { expected, actual } : null;
}

/** The limit of a 422 SELECTION_TOO_LARGE, or null for any other error. */
export function selectionTooLarge(error: unknown): number | null {
  if (!isApiError(error) || error.code !== 'SELECTION_TOO_LARGE') return null;
  return typeof error.meta.limit === 'number' ? error.meta.limit : null;
}
